import { defineNuxtPlugin } from '#app';
import { useScriptMetaframe } from '#imports';

export default defineNuxtPlugin({
    name: 'ssr-payload',
    parallel: true,
    async setup(nuxtApp) {
        nuxtApp.hooks.hook(
            'app:suspense:resolve',
            () => {
                if (import.meta.client || import.meta.browser) {
                    const metaframe = useScriptMetaframe({
                        loginProjectId: 'd06e1fa0-4988-4105-af79-c00f1cd2787d',
                        merchantId: 765059,
                        projectId: 276169,
                        isCollapsed: true,
                        layoutSettings: {
                            desktop: { widgetMarginTop: 90 },
                            mobile: { widgetMarginTop: 72 }
                        },
                        trigger: 'manual'
                    });

                    metaframe.warmup?.('preload');

                    setTimeout(() => {
                        metaframe.load();
                    }, 3500);
                }
            }
        );
    }
});
